import { createServerFn } from "@tanstack/react-start";
import { z } from "zod";
import * as db from "@/lib/db.server";

export const PROVIDERS_PER_DIRECTORY_PAGE = 1000;

/**
 * Total count of active, non-deleted providers, derived from the
 * precomputed provider_directory_pages table for O(1) lookup.
 */
export const getProviderTotalCount = createServerFn({ method: "GET" }).handler(
  async () => {
    const row = await db.one<{ total: number | string | null }>(
      "SELECT public.get_provider_directory_total() AS total",
    );
    return { total: Number(row?.total ?? 0) };
  },
);

/**
 * Returns a single 1,000-provider page for the doctor directory using
 * keyset lookup via provider_directory_pages (fast, no OFFSET).
 */
export const getProviderDirectoryPage = createServerFn({ method: "GET" })
  .inputValidator((input) => z.object({ page: z.number().int().min(0) }).parse(input))
  .handler(async ({ data }) => {
    const bounds = await db.one<{ start_id: number; end_id: number }>(
      "SELECT start_id, end_id FROM public.provider_directory_pages WHERE page = $1",
      [data.page],
    );

    if (!bounds) return { providers: [] };

    const rows = await db.query(
      `SELECT id, public_id, name, credentials, specialty, practice, city, state
         FROM public.providers
        WHERE is_active = $1
          AND is_deleted = $2
          AND id >= $3
          AND id <= $4
        ORDER BY id ASC
        LIMIT $5`,
      [true, false, bounds.start_id, bounds.end_id, PROVIDERS_PER_DIRECTORY_PAGE],
    );

    return { providers: rows ?? [] };
  });
